module.exports = __webpack_public_path__ + "static/media/icono-whatsapp.12713874.svg";